<template>
    <a-modal :visible="visible"
             :title="title"
             :width="`${modalWidth*0.85}px`"
             :mask="true"
             @cancel="close"
             :bodyStyle="customStyle"
             class="modal-content"
             :maskClosable="false"
             :centered="true">
        <div slot="footer">
            <a-button-group style="float: left">
                <go-pop-confirm title="该单据确定重新扫描?"
                                @confirm="handleReScan"
                                :disabled="loading"
                                v-if="hasScan">
                    <a-button type="danger" :disabled="loading">重新扫描</a-button>
                </go-pop-confirm>
                <a-dropdown>
                    <a-menu slot="overlay">
                        <a-menu-item :key="1" @click="exportBarcodeExcel('条码校验明细')">
                            <a-icon type="download"/>
                            导出条码
                        </a-menu-item>
                        <a-menu-item :key="2" @click="handleImport">
                            <a-icon type="import"/>
                            导入条码
                        </a-menu-item>
                    </a-menu>
                    <a-button :disabled="loading" icon="menu-fold">导入导出</a-button>
                </a-dropdown>
                <a-dropdown>
                    <a-menu slot="overlay" @click="handleScanMenuClick">
                        <a-menu-item :key="1">
                            <a-icon type="caret-right"/>
                            条形码
                        </a-menu-item>
                    </a-menu>
                    <a-button :disabled="loading" icon="scan">扫描</a-button>
                </a-dropdown>
            </a-button-group>
            <div style='display: flex;flex-direction: row;justify-content: flex-end;'>
                <a-button @click="handleReadBarcode" type="primary" :disabled="loading" v-if="errorDataList.length!==0">重新解析</a-button>
                <a-button @click="handleOk" type="primary" :disabled="loading" v-if="errorDataList.length===0">{{ keepBillQuantity ? '确认核对' : '保存' }}</a-button>
                <a-button @click="close" :disabled="loading">关闭</a-button>
            </div>
        </div>
        <a-spin :spinning="loading">
            <div v-if='errorDataList.length !== 0 '>
                <go-edit-table :height="modalHeight-56"
                               :dataSource="errorDataList"
                               :columns="errorHeadColumn">
                    <div slot="action" slot-scope="{record}">
                        <a-button size="small" icon="profile" style="margin-right: 5px;height: 16px;" @click="handleDelete(record)" type="link">
                            删除
                        </a-button>
                    </div>
                </go-edit-table>
            </div>
            <div v-else>
                <go-edit-table :height="modalHeight-56"
                               :dataSource="multiDataList"
                               :columns="headColumn"
                               bordered
                               :edit="false">
                    <div style="display: flex;flex-direction: row;justify-content: flex-start;" :slot="'x_'+item" v-for="(item,index) in maxSizeIndex" slot-scope="{text, record}" :key="index">
                        <template v-if="record['x_' + item] || record['act_x_' + item]">
                            <div style="width: 50px;padding: 4px;"> 订: {{ record['x_' + item] }}</div>
                            <div style="width: 50px;padding: 4px;" @click='handleShowBarcode(record,item)'
                                 :class="record['x_' + item] > record['act_x_' + item]?'primary-color-4':record['x_' + item] < record['act_x_' + item]?'tip-error':''">
                                扫: {{ record['act_x_' + item] }}
                            </div>
                        </template>
                    </div>
                </go-edit-table>
            </div>
        </a-spin>
        <in-upload-barcode-import-modal ref="importModal" :relationId="no" @ok='handleUploadOk'/>
        <barcode-import-modal ref="barcodeImportModal" @orderImport="handleOrderImport"/>
        <wms-show-barcode-modal ref='showBarcodeModal' @ok='load'/>
        <a-modal :visible="differenceVisible"
                 title="条码核对差异确认"
                 :width="`${modalWidth*0.72}px`"
                 :bodyStyle="differenceBodyStyle"
                 :maskClosable="false"
                 :centered="true"
                 @cancel="differenceVisible = false">
            <a-spin :spinning="loading" tip="正在生成差异处理草稿单据...">
                <div class="difference-summary">
                    <div class="difference-summary-item">
                        <div class="difference-summary-label">原单数量</div>
                        <div class="difference-summary-value">{{ differenceSummary.billQuantity }}</div>
                    </div>
                    <div class="difference-summary-item">
                        <div class="difference-summary-label">实扫数量</div>
                        <div class="difference-summary-value">{{ differenceSummary.actQuantity }}</div>
                    </div>
                    <div class="difference-summary-item short">
                        <div class="difference-summary-label">少收</div>
                        <div class="difference-summary-value">{{ differenceSummary.shortSkuCount }}款 / {{ differenceSummary.shortQuantity }}件</div>
                    </div>
                    <div class="difference-summary-item over">
                        <div class="difference-summary-label">多收</div>
                        <div class="difference-summary-value">{{ differenceSummary.overSkuCount }}款 / {{ differenceSummary.overQuantity }}件</div>
                    </div>
                </div>
                <a-alert class="difference-tip"
                         type="warning"
                         show-icon
                         message="确认后当前收货单仍按原单数量核对完成，系统将按下方差异明细生成对应处理单据。"/>
                <a-tabs default-active-key="short" class="difference-detail-tabs">
                    <a-tab-pane :tab="`少收明细(${shortDiffList.length})`" key="short">
                        <a-table :columns="differenceColumns"
                                 :dataSource="shortDiffList"
                                 :pagination="false"
                                 :scroll="differenceTableScroll"
                                 size="small"
                                 bordered
                                 rowKey="diffKey">
                            <template slot="billAction" slot-scope="text, record">
                                <span>{{ record.billAction }}</span>
                            </template>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane :tab="`多收明细(${overDiffList.length})`" key="over">
                        <a-table :columns="differenceColumns"
                                 :dataSource="overDiffList"
                                 :pagination="false"
                                 :scroll="differenceTableScroll"
                                 size="small"
                                 bordered
                                 rowKey="diffKey">
                            <template slot="billAction" slot-scope="text, record">
                                <span>{{ record.billAction }}</span>
                            </template>
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
            </a-spin>
            <template slot="footer">
                <a-button @click="differenceVisible = false" :disabled="loading">取消</a-button>
                <a-button type="primary" @click="handleDifferenceConfirm" :disabled="loading" :loading="loading">确认并生成处理单据</a-button>
            </template>
        </a-modal>
    </a-modal>
</template>

<script>
import {ModalMixin} from "@/utils/ModalMixin";
import {mixin} from "@/utils/mixin";
import {downFile, getAction, postAction} from "@/api/manage";
import MultiSizeTable from "@/components/tools/MultiSizeTable";
import GoEditTable from "@/components/tools/GoEditTable";
import {queryMultiSizeHead} from "@/api/api";
import InUploadBarcodeImportModal from "@views/goods/develop/modal/InUploadBarcodeImportModal";
import {formatTableData} from "@/utils/Tool";
import BarcodeImportModal from "@/tools/BarcodeImportModal";
import GoPopConfirm from "@comp/tools/GoPopConfirm";
import store from '@/store'
import WmsShowBarcodeModal from "@/views/order/base/modal/WmsShowBarcodeModal";

export default {
    name: "WarehouseInBarcodeVerifyModal",
    components: {WmsShowBarcodeModal, GoPopConfirm, BarcodeImportModal, InUploadBarcodeImportModal, GoEditTable, MultiSizeTable},
    mixins: [ModalMixin, mixin],
    props: {
        wmsNo: {
            type: String,
            required: true
        },
        warehouseId: {
            type: String,
            required: true
        },
        keepBillQuantity: {
            type: Boolean,
            default: false
        },
        differenceScene: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            title: '条码校验',
            no: null,
            titleHeight: 1,
            errorDataList: [],
            noReadDataList: [],
            sizeList: [],
            headColumn: [],
            showSizeList: [],
            multiDataList: [],
            dataList: [],
            maxSizeIndex: null,
            hasScan: false,
            differenceVisible: false,
            errorHeadColumn: [
                {
                    title: '条码',
                    dataIndex: 'barcode',
                    width: 120,
                    ellipsis: true,
                },
                {
                    title: '信息',
                    dataIndex: 'readMessage',
                    width: 120,
                    ellipsis: true,
                },
                {
                    title: '操作',
                    dataIndex: 'opt',
                    width: 120,
                    scopedSlots: {
                        customRender: 'action',
                    },
                }
            ],
            columnList: [
                {
                    title: '商品编号',
                    dataIndex: 'goodsNo',
                    width: 120,
                }, {
                    title: '商品名称',
                    dataIndex: 'goodsName',
                    width: 120,
                }, {
                    title: '色名',
                    dataIndex: 'colorNo',
                    width: 100,
                    customRender: (text, record, index) => `[${record.colorNo}]${record.colorName}`
                }, {
                    title: '内码',
                    dataIndex: 'specNo',
                    width: 60,
                }, {
                    title: '尺码多列头',
                    width: 80,
                    type: 'multiSizeHead',
                    canEdit: true,
                }],
            url: {
                list: '/bill/warehouseIn/listUploadBarcode',
                exportDetail: '/sys/export/exportInUploadBarcode',
                readBarcode: '/bill/warehouseIn/readBarcode',
                upload: '/bill/warehouseIn/saveUploadBarcode',
                reScan: '/bill/warehouseIn/reScan'
            },
            differenceColumns: [
                {
                    title: '商品编号',
                    dataIndex: 'goodsNo',
                    width: 110,
                },
                {
                    title: '商品名称',
                    dataIndex: 'goodsName',
                    width: 130,
                    ellipsis: true,
                },
                {
                    title: '色名',
                    dataIndex: 'colorText',
                    width: 120,
                    ellipsis: true,
                },
                {
                    title: '内码',
                    dataIndex: 'specNo',
                    width: 70,
                },
                {
                    title: '尺码',
                    dataIndex: 'sizeName',
                    width: 70,
                },
                {
                    title: '原单数量',
                    dataIndex: 'billQuantity',
                    width: 80,
                    align: 'right',
                },
                {
                    title: '实扫数量',
                    dataIndex: 'actQuantity',
                    width: 80,
                    align: 'right',
                },
                {
                    title: '差异数量',
                    dataIndex: 'diffQuantity',
                    width: 80,
                    align: 'right',
                },
                {
                    title: '将生成单据',
                    dataIndex: 'billAction',
                    width: 180,
                    scopedSlots: {customRender: 'billAction'}
                }
            ],
            orderDataList: []
        }
    },
    methods: {
        view: function (dataList, no) {
            this.multiDataList.length = 0
            this.errorDataList.length = 0
            this.no = no
            this.visible = true
            this.orderDataList = dataList
            this.errorDataList.length = 0
            this.load()
        },
        load: function () {
            this.loading = true
            this.dataList.length = 0
            getAction(this.url.list, {no: this.wmsNo}).then(res => {
                if (res.success) {
                    this.hasScan = true
                    let readList = []
                    res.result.forEach(item => {
                        if (item.readFlag === 0 || item.readFlag === -1) {
                            this.errorDataList.push(item)
                        } else if (item.readFlag === 1) {
                            readList.push(item)
                        }
                    })
                    if (this.errorDataList.length > 0) {
                        this.errorDataList = formatTableData(this.errorDataList)
                        return
                    }
                    let sumList = []
                    readList.forEach(item => {
                        let find = sumList.find(temp => {
                            return temp.goodsId === item.goodsId && temp.colorId === item.colorId && temp.specId === item.specId && temp.sizeId === item.sizeId
                        })
                        if (!find) {
                            find = {...item}
                            find.quantity = 0
                            find.id = sumList.length + 1
                            find.detailList = []
                            sumList.push(find)
                        }
                        find.quantity = find.quantity + item.quantity
                    })

                    this.orderDataList.forEach(item => {
                        let temp = {...item}
                        let find = sumList.find(tempItem => {
                            return item.goodsId === tempItem.goodsId && item.colorId === tempItem.colorId &&
                                item.sizeId === tempItem.sizeId && item.specId === tempItem.specId
                        })
                        if (find) {
                            if (item.quantity <= find.quantity) {
                                item.actQuantity = item.quantity
                                find.quantity = find.quantity - item.quantity
                                find.detailList.push(item)
                                if (find.quantity === 0) {
                                    sumList.splice(sumList.findIndex(item => item.id === find.id), 1)
                                }
                            } else {
                                item.actQuantity = find.quantity
                                sumList.splice(sumList.findIndex(item => item.id === find.id), 1)
                            }
                        } else {
                            item.actQuantity = 0
                        }
                    })
                    let leftList = sumList.filter(item => {
                        return item.detailList.length > 0
                    })

                    leftList.forEach(item => {
                        let temp = item.detailList[item.detailList.length - 1]
                        temp.actQuantity = temp.actQuantity + item.quantity
                    })

                    let newList = sumList.filter(item => {
                        return item.detailList.length === 0
                    })
                    this.orderDataList.forEach(item => {
                        this.dataList.push(item)
                    })
                    newList.forEach(item => {
                        let temp = {...item}
                        temp.quantity = 0
                        temp.actQuantity = item.quantity
                        temp.goodsId = item.goodsId
                        temp.sizeId = item.sizeId
                        temp.colorId = item.colorId
                        temp.specId = item.specId
                        temp.goodsName = item.goodsName
                        temp.goodsNo = item.goodsNo
                        temp.colorNo = item.colorNo
                        temp.sortNo = item.sortNo
                        this.dataList.push(temp)
                    })
                    this.formatData()
                    this.initTitle()
                }
            }).finally(res => {
                this.loading = false
            })
        },
        getTitle: function (sizeGroup, index) {
            if ((index - 1) < sizeGroup.detailList.length) {
                return sizeGroup.detailList[index - 1].sizeName
            } else {
                return ""
            }
        },
        initTitle: function () {
            let systemParam = store.getters.systemParam
            this.showSizeList.length = 0
            this.multiDataList.forEach((item, index) => {
                let find = this.showSizeList.find(tempItem => {
                    return tempItem.id === item.sizeGroupId
                })
                if (!find) {
                    let sizeGroup = this.sizeList.find(tempItem => {
                        return tempItem.id === item.sizeGroupId
                    })
                    if (sizeGroup) {
                        this.showSizeList.push(sizeGroup)
                    }
                }
            })
            this.headColumn.length = 0
            this.columnList.forEach(item => {
                if (item.type === 'multiSizeHead') {
                    let multiSize = this.multiSizeHead(this.showSizeList, item)
                    multiSize.forEach(i => {
                        this.headColumn.push(i)
                    })
                } else {
                    if (!(systemParam.hiddenSpec && item.dataIndex === 'specNo')) {
                        this.headColumn.push(item)
                    }
                }
            })
        },
        multiSizeHead: function (sizeGroupList, field) {
            let max = 0
            sizeGroupList.forEach(item => {
                if (item.detailList.length > max) {
                    max = item.detailList.length
                }
            })
            this.maxSizeIndex = max
            let result = []
            for (let i = 1; i <= max; i++) {
                let tempColumn = null;
                for (let j = 0; j < sizeGroupList.length; j++) {
                    let temp = {}
                    temp.title = this.getTitle(sizeGroupList[j], i)
                    temp.dataIndex = "x_" + i
                    temp.width = field.width
                    temp.sum = true
                    temp.type = "Text"
                    temp.canEdit = false
                    temp.slotIgnore = false
                    temp.scopedSlots = {customRender: temp.dataIndex}
                    temp.validateRules = [{pattern: 'money', message: '必须为数字'}]
                    if (j === 0) {
                        result.push(temp)
                    } else if (j > 0) {
                        tempColumn.children = []
                        tempColumn.children.push(temp)
                    }
                    tempColumn = temp
                }
            }
            this.titleHeight = sizeGroupList.length
            return result;
        },
        formatData: function () {
            let that = this
            this.multiDataList = []
            if (this.dataList) {
                this.dataList.forEach(item => {
                    let find = this.multiDataList.find(multiItem => {
                        return this.filter(multiItem, item)
                    })
                    if (!find) {
                        find = {...item}
                        find['key'] = that.genRandomKey(5)
                        find.quantity = null
                        find.actQuantity = null
                        delete find.sizeId
                        if (this.allEdit) {
                            find.editable = true
                        }
                        this.multiDataList.push(find)
                    }
                    find['x_' + item.sortNo] = item.quantity === null ? '' : item.quantity
                    find['act_x_' + item.sortNo] = item.actQuantity === null ? '' : item.actQuantity
                    item.key = find.key
                })
            }
        },
        filter: function (multiItem, item) {
            return multiItem.goodsId === item.goodsId &&
                multiItem.colorId === item.colorId &&
                multiItem.specId === item.specId
        },
        exportBarcodeExcel: function (fileName) {
            if (!fileName || typeof fileName !== "string") {
                fileName = "导出文件"
            }
            this.loading = true
            let params = {no: this.no}
            let showFields = null
            let searchCondition = [];
            searchCondition.push(`单号：${this.no}`)
            downFile(this.url.exportDetail, {query: params, showFields: showFields, searchCondition: searchCondition}).then(data => {
                if (!data || data.size === 0) {
                    this.$message.warning("文件下载失败")
                    return
                }
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(new Blob([data], {type: 'application/vnd.ms-excel'}), fileName + '.xlsx')
                } else {
                    let url = window.URL.createObjectURL(new Blob([data], {type: 'application/vnd.ms-excel'}))
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', fileName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleOk: function () {
            if (this.keepBillQuantity) {
                if (this.hasQuantityDiff()) {
                    this.differenceVisible = true
                    return
                }
                this.$confirm({
                    title: '确认核对完成?',
                    content: '当前无实扫差异，确认标记核对完成?',
                    onOk: () => {
                        this.$emit("save", this.buildDifferenceConfirmData())
                    }
                })
                return
            }
            this.$emit("save")
        },
        handleDifferenceConfirm: function () {
            this.loading = true
            this.$emit("save", this.buildDifferenceConfirmData())
        },
        finishDifferenceConfirm: function (closeFlag) {
            this.loading = false
            if (closeFlag) {
                this.differenceVisible = false
            }
        },
        hasQuantityDiff: function () {
            return this.dataList.some(item => {
                let billQuantity = Number(item.quantity || 0)
                let actQuantity = Number(item.actQuantity || 0)
                return billQuantity !== actQuantity
            })
        },
        buildDifferenceConfirmData: function () {
            return {
                billId: this.no,
                wmsNo: this.wmsNo,
                scene: this.differenceScene,
                summary: this.differenceSummary,
                shortList: this.shortDiffList,
                overList: this.overDiffList
            }
        },
        buildDifferenceList: function (diffType) {
            return this.dataList.filter(item => {
                let billQuantity = Number(item.quantity || 0)
                let actQuantity = Number(item.actQuantity || 0)
                return diffType === 'SHORT' ? billQuantity > actQuantity : actQuantity > billQuantity
            }).map(item => {
                let billQuantity = Number(item.quantity || 0)
                let actQuantity = Number(item.actQuantity || 0)
                let diffQuantity = diffType === 'SHORT' ? billQuantity - actQuantity : actQuantity - billQuantity
                return {
                    diffKey: `${item.goodsId || ''}_${item.colorId || ''}_${item.specId || ''}_${item.sizeId || ''}_${diffType}`,
                    diffType: diffType,
                    goodsId: item.goodsId,
                    colorId: item.colorId,
                    specId: item.specId,
                    sizeId: item.sizeId,
                    goodsNo: item.goodsNo,
                    goodsName: item.goodsName,
                    colorText: item.colorNo ? `[${item.colorNo}]${item.colorName || ''}` : (item.colorName || ''),
                    specNo: item.specNo,
                    sizeName: item.sizeName,
                    billQuantity: billQuantity,
                    actQuantity: actQuantity,
                    diffQuantity: diffQuantity,
                    billAction: this.getDifferenceBillAction(diffType)
                }
            })
        },
        getDifferenceBillAction: function (diffType) {
            let actionMap = {
                saleInput: {
                    SHORT: '生成门店退货单（草稿）',
                    OVER: '生成补发销售出货单（草稿）'
                },
                stockmoveInput: {
                    SHORT: '生成反向渠道调出单（草稿）',
                    OVER: '生成补发渠道调出单（草稿）'
                },
                salebackInput: {
                    SHORT: '生成收退货差异退回单（草稿）',
                    OVER: '生成追加门店退货单（草稿）'
                }
            }
            let sceneAction = actionMap[this.differenceScene] || {}
            return sceneAction[diffType] || (diffType === 'SHORT' ? '生成少收差异处理单（草稿）' : '生成多收差异处理单（草稿）')
        },
        handleUploadOk: function () {
            this.load()
        },
        handleReadBarcode: async function () {
            let times = Math.ceil(this.errorDataList.length / 10)
            this.loading = true
            try {
                for (let i = 0; i < times; i++) {
                    let start = i * 10
                    let postList = []
                    for (let j = 0; j < 10; j++) {
                        if ((start + j) > (this.errorDataList.length - 1)) {
                            break;
                        }
                        postList.push(this.errorDataList[start + j])
                    }
                    await postAction(this.url.readBarcode, postList)
                }
            } finally {
                this.loading = false
                this.errorDataList.length = 0
                this.load()
            }
        },
        handleScanMenuClick: function ({key}) {
            if (key === 1) {
                this.$refs.barcodeImportModal.show({warehouseId: this.warehouseId, billVerify: true, no: this.wmsNo, type: 1})
            }
        },
        handleOrderImport: function ({barcodeList}) {
            let data = {
                barcodeList: {
                    addList: barcodeList,
                    updateList: [],
                    deleteList: [],
                },
                no: this.wmsNo
            }
            this.loading = true
            postAction(this.url.upload, data).then(res => {
                if (res.success) {
                    this.load()
                    this.$refs.barcodeImportModal.reset()
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleReScan: function () {
            this.loading = true
            getAction(this.url.reScan, {no: this.no}).then(res => {
                if (res.success) {
                    this.$message.success("操作成功")
                    this.multiDataList.length = 0
                    this.errorDataList.length = 0
                    this.$refs.barcodeImportModal.clear()
                    this.load()
                }
            }).finally(res => {
                this.loading = false
            })
        },
        handleDelete: function (record) {
            this.loading = true
            getAction(this.url.delete, {id: record.id}).then(res => {
                if (res.success) {
                    this.multiDataList.length = 0
                    this.errorDataList.length = 0
                    this.load()
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleShowBarcode: function (record, sortNo) {
            let sizeGroup = this.sizeList.find(item => {
                return item.id === record.sizeGroupId
            })
            let size = sizeGroup.detailList.find(item => {
                return item.sortNo === sortNo
            })
            this.$refs.showBarcodeModal.show({
                goodsId: record.goodsId,
                colorId: record.colorId,
                specId: record.specId,
                sizeId: size.id,
                wmsNo: this.wmsNo,
                type: 2
            })
        }
    },
    mounted: function () {
        let that = this
        queryMultiSizeHead().then(res => {
            if (res.success) {
                that.sizeList = res.result
                that.initTitle()
            }
        })
    },
    computed: {
        customStyle: function () {
            let bodyStyle = {...this.modalStyle}
            bodyStyle.maxHeight = this.modalHeight + "px"
            bodyStyle.height = this.modalHeight + "px";
            bodyStyle.padding = "4px"
            return bodyStyle
        },
        differenceBodyStyle: function () {
            return {
                height: '560px',
                overflow: 'hidden',
                padding: '16px'
            }
        },
        differenceTableScroll: function () {
            return {
                x: 1020,
                y: 300
            }
        },
        shortDiffList: function () {
            return this.buildDifferenceList('SHORT')
        },
        overDiffList: function () {
            return this.buildDifferenceList('OVER')
        },
        differenceSummary: function () {
            let shortQuantity = this.shortDiffList.reduce((sum, item) => sum + item.diffQuantity, 0)
            let overQuantity = this.overDiffList.reduce((sum, item) => sum + item.diffQuantity, 0)
            return {
                billQuantity: this.dataList.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
                actQuantity: this.dataList.reduce((sum, item) => sum + Number(item.actQuantity || 0), 0),
                shortSkuCount: this.shortDiffList.length,
                shortQuantity: shortQuantity,
                overSkuCount: this.overDiffList.length,
                overQuantity: overQuantity
            }
        },
    },
}
</script>

<style scoped>
.tip-error {
    background-color: red;
    color: #ffffff;
}

.difference-summary {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    margin-bottom: 10px;
}

.difference-summary-item {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px 12px;
    background: #fafafa;
}

.difference-summary-item.short {
    border-color: #ffd591;
    background: #fff7e6;
}

.difference-summary-item.over {
    border-color: #ffa39e;
    background: #fff1f0;
}

.difference-summary-label {
    color: #666;
    line-height: 18px;
}

.difference-summary-value {
    color: #111;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
}

.difference-tip {
    margin-bottom: 10px;
}

.difference-detail-tabs {
    height: 420px;
    overflow: hidden;
}
</style>
